import { createAction, props } from '@ngrx/store';
import { IUserInvation } from './interfaces/user-portfolio-invites.interface';

export const USER_PORTFOLIO_FEATURE_NAME = 'user_invites';

export const getUserInvations = createAction(
  `[${USER_PORTFOLIO_FEATURE_NAME}] Get User Invations`,
);

export const getUserInvationsSuccess = createAction(
  `[${USER_PORTFOLIO_FEATURE_NAME}] Get User Invations Success`,
  props<{ data: IUserInvation[] }>(),
);

export const acceptInvite = createAction(
  `[${USER_PORTFOLIO_FEATURE_NAME}] Accept Invite`,
  props<{ inviteId: string }>(),
)

export const rejectInvite = createAction(
  `[${USER_PORTFOLIO_FEATURE_NAME}] Reject Invite`,
  props<{ inviteId: string }>(),
)

export const clearStore = createAction(
  `[${USER_PORTFOLIO_FEATURE_NAME}] Clear store`,
)
